module.exports = "/virtual-football-league/img/video/clubs/spain/barcelona.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/spain/barcelona.png
// module id = 355
// module chunks = 4